import {FC} from "react";
import { PageEnum, TrialBalanceReportSearchParamsModel} from "../../../models";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import { ReportPage, ReportTrialBalancePageSearchPanel} from "../../../components";
import {
    searchTrialBalanceReport
} from "../../../serviceBroker/acTransactionReportApiServiceBroker";

export const ReportTrialBalancePage: FC = () => {
    const initialState: TrialBalanceReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        userId: getUserId(),
        isShowReportAsSummery:false,
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchTrialBalanceReport}
            searchHeader={getPageNameByPageId(PageEnum.TrialBalance)}
            SearchPanel={ReportTrialBalancePageSearchPanel}
            formId={PageEnum.TrialBalance}
        />
    );
};